import { httpClient, httpClient3 } from "./Api";
import { message } from "antd";
import moment from "moment";

const showUrl = false;

const typedResponse = (type, callbackFun, data, url) => {
  if (!callbackFun) return;

  if (Array.isArray(data)) {
    return callbackFun(data);
  }

  if (
    typeof data === "string" &&
    moment(data, "YYYY-MM-DDTHH:mm:ss", true).isValid()
  ) {
    return callbackFun(moment(data, "YYYY-MM-DDTHH:mm:ss"));
  }

  if (type === "dataset") {
    return callbackFun(data.DataSet || data.dataSet || {});
  }

  // ✅ Handle DataSet cases (both single Table and multiple Tables)
  if (
    data?.DataSet &&
    typeof data.DataSet === "object" &&
    Object.keys(data.DataSet).length > 0
  ) {
    const ds = data.DataSet;

    // If response has multiple tables (billDataAfterCloseVisit style)
    if (ds.Table1 || ds.Table2 || ds.Table3) {
      return callbackFun(ds); // return full object
    }

    // If only a single Table array exists
    if (Array.isArray(ds.Table)) {
      return callbackFun(ds.Table);
    }

    // fallback
    return callbackFun(ds);
  }

  if (type === "data") {
    return callbackFun(data.dataSet || data.ResponseArray || []);
  }

  if (type === "msg") {
    let msg = data.Message || "";
    if (data.Id !== undefined && data.Id !== null) {
      msg = msg ? `${msg}, ${data.Id}` : `${data.Id}`;
    }
    return callbackFun(msg);
  }

  if (data && data.Id) {
    return callbackFun({ id: data.Id, message: data.Message || "" });
  }
  if (data && "ResponseObject" in data && Array.isArray(data.ResponseObject)) {
    return callbackFun(data.ResponseObject);
  }
  if (data && "ResponseArray" in data) {
    return callbackFun(
      Array.isArray(data.ResponseArray) ? data.ResponseArray : [],
    );
  }

  if (typeof data.data === "boolean") {
    return callbackFun(data.data);
  }

  if (data.IsSuccessfull && data.StatusCode === 200) {
    if (type === "data") {
      if (
        !data.dataSet &&
        !data.ResponseArray &&
        data.Data &&
        typeof data.Data === "object" &&
        Object.keys(data.Data).length > 0
      ) {
        return callbackFun(data.Data);
      }
      return callbackFun(data.dataSet || data.ResponseArray || []);
    }
    if (data.Id) {
      return callbackFun({ id: data.Id, message: data.Message || "" });
    } else if (type === "msg") {
      let msg = data.Message || "";
      if (data.Id !== undefined && data.Id !== null) {
        msg = msg ? `${msg}, ${data.Id}` : `${data.Id}`;
      }
      return callbackFun(msg);
    }
  }

  if (data?.StatusCode === 404 || data?.Message === "No Data Found") {
    return callbackFun(null);
  }

  if (!data || Object.keys(data).length === 0) {
    return callbackFun(null);
  }
};

// const typedResponse = (type, callbackFun, data, url) => {
//   if (!callbackFun) return;

//   if (Array.isArray(data)) {
//     return callbackFun(data);
//   }

//   if (
//     typeof data === "string" &&
//     moment(data, "YYYY-MM-DDTHH:mm:ss", true).isValid()
//   ) {
//     return callbackFun(moment(data, "YYYY-MM-DDTHH:mm:ss"));
//   }

//   if (type === "dataset") {
//     return callbackFun(data.DataSet || data.dataSet || {});
//   }

//   if (
//     data?.DataSet &&
//     typeof data.DataSet === "object" &&
//     Object.keys(data.DataSet).length > 0
//   ) {
//     return callbackFun(data.DataSet);
//   }

//   if (type === "data") {
//     return callbackFun(data.dataSet || data.ResponseArray || []);
//   }

//   if (type === "msg") {
//     let msg = data.Message || "";
//     if (data.Id !== undefined && data.Id !== null) {
//       msg = msg ? `${msg}, ${data.Id}` : `${data.Id}`;
//     }
//     return callbackFun(msg);
//   }

//   if (data && data.Id) {
//     return callbackFun({ id: data.Id, message: data.Message || "" });
//   }

//   if (data && "ResponseArray" in data) {
//     return callbackFun(
//       Array.isArray(data.ResponseArray) ? data.ResponseArray : []
//     );
//   }

//   if (typeof data.data === "boolean") {
//     return callbackFun(data.data);
//   }

//   if (data.IsSuccessfull && data.StatusCode === 200) {
//     if (type === "data") {
//       if (
//         !data.dataSet &&
//         !data.ResponseArray &&
//         data.Data &&
//         typeof data.Data === "object" &&
//         Object.keys(data.Data).length > 0
//       ) {
//         return callbackFun(data.Data);
//       }
//       return callbackFun(data.dataSet || data.ResponseArray || []);
//     }
//     if (data.Id) {
//       return callbackFun({ id: data.Id, message: data.Message || "" });
//     } else if (type === "msg") {
//       let msg = data.Message || "";
//       if (data.Id !== undefined && data.Id !== null) {
//         msg = msg ? `${msg}, ${data.Id}` : `${data.Id}`;
//       }
//       return callbackFun(msg);
//     }
//   }

//   if (data?.StatusCode === 404 || data?.Message === "No Data Found") {
//     return callbackFun(null);
//   }

//   if (!data || Object.keys(data).length === 0) {
//     return callbackFun(null);
//   }
// };

const oldTypedResponse = (type, callbackFun, data) => {
  if (callbackFun) {
    if (Array.isArray(data) && data?.length) {
      callbackFun(data);
    } else if (data?.Value?.table?.length) {
      callbackFun(data?.Value?.table);
    } else {
      callbackFun([]);
    }
  }
};

export const getApi = (url, callbackFun, type, getLogout, loading) => {
  if (loading) message.loading("Please Wait...", 0);
  httpClient
    .get(url)
    .then(({ data }) => {
      if (loading) message.destroy();
      typedResponse(type, callbackFun, data, url);
    })
    .catch(function (error) {
      onErrorCatch(error, loading, getLogout, url);
    });
};

// Only Need to Call It When we work with old API Controllers
export const getOldApi = (url, callbackFun, type, getLogout, loading) => {
  if (loading) message.loading("Please Wait...", 0);
  httpClient
    .get(url)
    .then(({ data }) => {
      if (loading) message.destroy();
      oldTypedResponse(type, callbackFun, data);
    })
    .catch(function (error) {
      onErrorCatch(error, loading, getLogout, url);
    });
};

export const getBooleanApi = (url, callbackFun, type, getLogout, loading) => {
  if (loading) message.loading("Please Wait...", 0);
  httpClient
    .get(url)
    .then((isResponse) => {
      if (loading) message.destroy();
      typedResponse(type, callbackFun, isResponse, url);
    })
    .catch(function (error) {
      onErrorCatch(error, loading, getLogout, url);
    });
};

export const postApi = (
  url,
  body,
  callbackFun,
  type,
  getLogout,
  loading,
  isMultiPart,
) => {
  if (loading) message.loading("Please Wait...", 0);

  if (isMultiPart && body) {
    httpClient3
      .post(url, body)
      .then(({ data }) => {
        if (loading) message.destroy();
        typedResponse(type, callbackFun, data, url);
      })
      .catch(function (error) {
        onErrorCatch(error, loading, getLogout, url);
      });
  } else if (body) {
    httpClient
      .post(url, body)
      .then(({ data }) => {
        if (loading) message.destroy();
        typedResponse(type, callbackFun, data, url);
      })
      .catch(function (error) {
        onErrorCatch(error, loading, getLogout, url);
      });
  } else {
    httpClient
      .post(url)
      .then(({ data }) => {
        if (loading) message.destroy();
        typedResponse(type, callbackFun, data, url);
      })
      .catch(function (error) {
        onErrorCatch(error, loading, getLogout, url);
      });
  }
};

export const putApi = (
  url,
  body,
  callbackFun,
  type,
  getLogout,
  loading,
  showSuccess,
) => {
  if (loading) message.loading("Please Wait...", 0);
  if (body) {
    httpClient
      .put(url, body)
      .then(({ data }) => {
        if (loading) message.destroy();
        typedResponse(type, callbackFun, data, url);
      })
      .catch(function (error) {
        onErrorCatch(error, loading, getLogout, url);
      });
  } else {
    httpClient
      .put(url)
      .then(({ data }) => {
        if (loading) message.destroy();
        typedResponse(type, callbackFun, data, url);
      })
      .catch(function (error) {
        onErrorCatch(error, loading, getLogout, url);
      });
  }
};

export const deleteApi = (url, callbackFun, type, getLogout, loading) => {
  if (loading) message.loading("Please Wait...", 0);
  httpClient
    .delete(url)
    .then(({ data }) => {
      if (loading) message.destroy();
      typedResponse(type, callbackFun, data, url);
    })
    .catch(function (error) {
      onErrorCatch(error, loading, getLogout, url);
    });
};

// const onErrorCatch = (error, loading, getLogout, url) => {
//   if (
//     error?.response?.data?.message ===
//       "Session has expired. Please log in again." ||
//     error?.response?.data?.message === "Token has expired."
//   ) {
//     message.warn(error.response.data.message);
//     getLogout();
//   }
//   if (loading) message.destroy();
//   // if (showUrl) message.error(`url: ${url}, message: ${error.message}`);
//   // if (!showUrl) message.error(error.message);
// };
const onErrorCatch = (error, loading, getLogout, url) => {
  message.destroy();

  const status = error?.response?.status;
  const serverMsg =
    error?.response?.data?.message || error?.response?.data?.Message || "";

  const isSessionExpired =
    status === 401 ||
    serverMsg === "Unauthorized." ||
    serverMsg === "Unauthorized" ||
    serverMsg === "Session has expired. Please log in again." ||
    serverMsg === "Token has expired.";

  if (isSessionExpired) {
    message.warn("Session has expired. Please log in again.");
    if (typeof getLogout === "function") getLogout();
  }
};
// const onErrorCatch = (error, loading, getLogout, url) => {
//   const messageText = error?.response?.data?.message;

//   if (
//     messageText === "Session has expired. Please log in again." ||
//     messageText === "Token has expired."
//   ) {
//     message.warn(messageText);
//     getLogout();
//   }

//   if (loading) message.destroy();
// };
